"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "usePortalMountNode", {
    enumerable: true,
    get: ()=>usePortalMountNode
});
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _reactSharedContexts = require("@fluentui/react-shared-contexts");
const _react1 = require("@griffel/react");
const _reactTabster = require("@fluentui/react-tabster");
const _useDisposable = require("use-disposable");
const useInsertionEffect = _react['useInsertion' + 'Effect'];
const useStyles = /*#__PURE__*/ (0, _react1["__styles"])({
    root: {
        qhf8xq: "f10pi13n",
        Bj3rh1h: "f494woh"
    }
}, {
    d: [
        ".f10pi13n{position:relative;}",
        ".f494woh{z-index:1000000;}"
    ]
});
const usePortalMountNode = (options)=>{
    const { targetDocument , dir  } = (0, _reactSharedContexts.useFluent_unstable)();
    const focusVisibleRef = (0, _reactTabster.useFocusVisible)();
    const classes = useStyles();
    const themeClassName = (0, _reactSharedContexts.useThemeClassName_unstable)();
    const className = (0, _react1.mergeClasses)(themeClassName, classes.root, options.className);
    const element = (0, _useDisposable.useDisposable)(()=>{
        if (targetDocument === undefined || options.disabled) {
            return [
                null,
                ()=>null
            ];
        }
        const newElement = targetDocument.createElement('div');
        targetDocument.body.appendChild(newElement);
        return [
            newElement,
            ()=>newElement.remove()
        ];
    }, [
        targetDocument
    ]);
    if (useInsertionEffect) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useInsertionEffect(()=>{
            if (!element) {
                return;
            }
            const classesToApply = className.split(' ').filter(Boolean);
            element.classList.add(...classesToApply);
            element.setAttribute('dir', dir);
            focusVisibleRef.current = element;
            return ()=>{
                element.classList.remove(...classesToApply);
                element.removeAttribute('dir');
            };
        }, [
            className,
            dir,
            element,
            focusVisibleRef
        ]);
    } else {
        // This useMemo call is intentional for React 17
        // We don't want to re-create the portal element when its attributes change.
        // This also should not be done in an effect because, changing the value of css variables
        // after initial mount can trigger interesting CSS side effects like transitions.
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useMemo(()=>{
            if (!element) {
                return;
            }
            // Force replace all classes
            element.className = className;
            element.setAttribute('dir', dir);
            focusVisibleRef.current = element;
        }, [
            className,
            dir,
            element,
            focusVisibleRef
        ]);
    }
    return element;
}; //# sourceMappingURL=usePortalMountNode.js.map

//# sourceMappingURL=usePortalMountNode.js.map